export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const WORKFLOW_LIST = "WORKFLOW_LIST";
export const DATA_UPDATED = "DATA_UPDATED";
export const DATA_EDIT = "DATA_EDIT";
export const ALL_UNIT = "ALL_UNIT";
export const ALL_APPROVER = "ALL_APPROVER";
export const ALL_DATA_APPROVER = "ALL_DATA_APPROVER";
export const SET_LOADING = "SET_LOADING";
export const SET_LOADING_UNIT = "SET_LOADING_UNIT";
export const SET_LOADING_APPROVER = "SET_LOADING_APPROVER";